// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg fill=%27gray%27 height=%2720%27 viewBox=%270 0 24 24%27 width=%2720%27 xmlns=%27http://www.w3.org/2000/svg%27><path d=%27M7 10l5 5 5-5z%27/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-card {
  /* background: #ffffff; */
  padding: 30px;
  border-radius: 12px;
  width: 420px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.close-btn {
  cursor: pointer;
  font-size: 18px;
}

.modal-card label {
  display: block;
  margin-top: 14px;
  font-weight: 500;
  font-size: 14px;
}

.modal-card input,
.custom-select {
  width: 100%;
  padding: 9px 12px;
  margin-top: 5px;
  border-radius: 8px;
  border: 1px solid #dcdcdc;
  font-size: 14px;
  transition: 0.2s ease;
}

.modal-card input:focus,
.custom-select:focus {
  outline: none;
  border-color: #22c55e;
  box-shadow: 0 0 0 2px rgba(34, 197, 94, 0.15);
}

/* Clean dropdown arrow */
.custom-select {
  appearance: none;
  background-color: #020617;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 10px center;
  background-size: 16px;
  cursor: pointer;
  color: white;
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 25px;
}

.cancel-btn {
  /* background: #f1f1f1; */
  border: none;
  padding: 8px 14px;
  border-radius: 8px;
  cursor: pointer;
}

.add-btn {
  background: #22c55e;
  color: white;
  border: none;
  padding: 8px 14px;
  border-radius: 8px;
  cursor: pointer;
  transition: 0.2s;
}

.add-btn:hover {
  background: #16a34a;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Masters/metal_purity_karat/Addmetal_purity_karat/Addmetal_purity_karat.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,qBAAqB;AACvB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,yBAAyB;EACzB,yDAAgL;EAChL,4BAA4B;EAC5B,sCAAsC;EACtC,qBAAqB;EACrB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.45);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.modal-card {\n  /* background: #ffffff; */\n  padding: 30px;\n  border-radius: 12px;\n  width: 420px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.close-btn {\n  cursor: pointer;\n  font-size: 18px;\n}\n\n.modal-card label {\n  display: block;\n  margin-top: 14px;\n  font-weight: 500;\n  font-size: 14px;\n}\n\n.modal-card input,\n.custom-select {\n  width: 100%;\n  padding: 9px 12px;\n  margin-top: 5px;\n  border-radius: 8px;\n  border: 1px solid #dcdcdc;\n  font-size: 14px;\n  transition: 0.2s ease;\n}\n\n.modal-card input:focus,\n.custom-select:focus {\n  outline: none;\n  border-color: #22c55e;\n  box-shadow: 0 0 0 2px rgba(34, 197, 94, 0.15);\n}\n\n/* Clean dropdown arrow */\n.custom-select {\n  appearance: none;\n  background-color: #020617;\n  background-image: url(\"data:image/svg+xml;utf8,<svg fill='gray' height='20' viewBox='0 0 24 24' width='20' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/></svg>\");\n  background-repeat: no-repeat;\n  background-position: right 10px center;\n  background-size: 16px;\n  cursor: pointer;\n  color: white;\n}\n\n.modal-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 25px;\n}\n\n.cancel-btn {\n  /* background: #f1f1f1; */\n  border: none;\n  padding: 8px 14px;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n.add-btn {\n  background: #22c55e;\n  color: white;\n  border: none;\n  padding: 8px 14px;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: 0.2s;\n}\n\n.add-btn:hover {\n  background: #16a34a;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
